export default __webpack_public_path__ + "static/media/toyota.0f4c4a70.svg";